import { render, staticRenderFns } from "./user-group-stat.vue?vue&type=template&id=ed4569a0&scoped=true&"
import script from "./user-group-stat.vue?vue&type=script&lang=js&"
export * from "./user-group-stat.vue?vue&type=script&lang=js&"
import style0 from "./user-group-stat.vue?vue&type=style&index=0&id=ed4569a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4569a0",
  null
  
)

export default component.exports